import React from "react";
import { Link } from "react-router-dom";

import "./LoyaltyOfferGrid.css";
import LoyaltyOfferCard from "../LoyaltyOfferCard/LoyaltyOfferCard";

export default function LoyaltyOfferGrid({ offers }) {
  console.log("offers prop:", offers);
  if (!offers || offers.length === 0) {
    return <p className="no-offers">No offers available.</p>;
  }

  return (
    <div className="offer-grid">
      {offers.map((offer) => (
        <Link
          key={offer.id}
          to={`/loyalty-program/${offer.id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <LoyaltyOfferCard offer={offer} />
        </Link>
      ))}
    </div>
  );
}
